<soft-pdf-editor
  [document]="document$ | async"
  (submit)="onSaveDocument($event)"
>
</soft-pdf-editor>
